import { ReactNode } from 'react';

import { cx } from '@libs/classnames';

import styles from './CapsuleButton.module.css';

export type Props = {
  id?: string;
  className?: string;
  type?: 'button' | 'reset' | 'submit';
  size?:
    | '16r-36'
    | '16m-40'
    | '16m-44'
    | '13m-32'
    | '13m-41'
    | '18r-33'
    | '22r-36'
    | '13m-28'
    | '16r-28'
    | '16r-32'
    | '20m-60';
  shadow?: 'strong' | 'weak';
  preset?:
    | 'hollow'
    | 'hollow-colored'
    | 'hollow-white'
    | 'hollow-golden'
    | 'call-to-action'
    | 'selected'
    | 'gray'
    | 'gray-faded'
    | 'call-to-action-black'
    | 'selected-inverted';
  children: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
};

export function CapsuleButton({
  id,
  className,
  preset = 'hollow',
  type = 'button',
  size = '16r-36',
  shadow,
  children,
  disabled,
  onClick,
}: Props) {
  return (
    <button
      id={id}
      type={type}
      className={cx(
        styles.button,
        className,
        styles[`size_${size}`],
        styles[`preset_${preset}`],
        shadow && styles[`shadow_${shadow}`],
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
